import React from "react";
import cx from "classnames";
import { graphql, navigate } from "gatsby";
import Layout from "../layout/index";
import Banner from "../components/Home/Hero";
import Carousel from "../components/Carousel";
import Button from "../components/Button";
import SEO from "../components/SEO/index.jsx";
import styles from "./index.module.scss";
import Accolades from "../components/Home/Accolades";
import Process from "../components/Home/Process";

export default function Home({ data }) {
  const featuredImages = data.allContentfulLookbook.edges;

  const Section = ({ children, className }) => (
    <div className={cx({ [className]: true, [styles.section]: true })}>
      {children}
    </div>
  );

  return (
    <Layout>
      <SEO />
      <Banner />
      <Accolades />
      <Section className={styles.process}>
        <h2>We’ll do the heavy lifting so you don't have to</h2>
        <Process />
        <div className={styles.callToAction}>
          <h2>Learn more about the benefits of using Greek Dressing.</h2>
          <div className={styles.button}>
            <Button
              onClick={() => navigate("/process")}
              children="How It Works"
            />
          </div>
        </div>
      </Section>
      <Section className={styles.lookbook}>
        <div className={styles.text}>
          <h2>
            A fresh take on Sorority and Fraternity apparel, or any organization
            for that matter
          </h2>
          <p>
            {`We pride ourselves on creating designs that stand out from
          the rest. Take a look at some of our favorite designs for ${new Date().getFullYear()}.`}
          </p>
        </div>
        <div className={styles.carousel}>
          <Carousel items={featuredImages} />
        </div>
        <div className={styles.button}>
          <Button
            onClick={() => navigate("/lookbook")}
            children="View Lookbook"
          />
        </div>
      </Section>
    </Layout>
  );
}

export const FeaturedImages = graphql`
  query {
    allContentfulLookbook(filter: { featured: { eq: true } }) {
      edges {
        node {
          name
          image {
            fluid {
              ...GatsbyContentfulFluid_withWebp
            }
          }
        }
      }
    }
  }
`;
